import gql from 'graphql-tag';

export const companySettingsQuery = gql`
  query CompanySettings {
    settings {
      kbUrl
    }
  }
`;
